// extracted by mini-css-extract-plugin
export default {"container":"Chip_container__HvPca","grey":"Chip_grey__Bgen3","gradient":"Chip_gradient__1H1i3","sm":"Chip_sm__Kgvcc","category":"Chip_category__vKbRb"};